import Modal from '../../../components/modal';
import CommentCheckIcon from '../../../assets/comment-check-icon';
import React from 'react';

const ReviewSent = ({ onBack }) => {
  return (
    <Modal>
      <div className="flex w-[90%] md:w-[50%] flex-col justify-center items-center bg-white p-6 border rounded-lg gap-6">
        <CommentCheckIcon size={48} />
        <h1 className="text-2xl md:text-4xl font-bold">Ulasan Angkutan Berhasil</h1>
        <h4 className="text-base">
          Terima Kasih telah mengulas angkutan ini, segala tindakan dalam pengisian ulasan ini akan
          menjadi penilaian kinerja angkutan.
        </h4>
        <button
          onClick={onBack}
          className="text-black bg-secondary-500 font-medium rounded-lg text-sm px-6 py-3"
        >
          Kembali
        </button>
      </div>
    </Modal>
  );
};

export default ReviewSent;
